function NotActive(message) {
  this.name = "NotActive";
  this.message = message || "";
  this.stack = new Error().stack;
}
NotActive.prototype = Object.create(Error.prototype);
NotActive.prototype.constructor = NotActive;

export default NotActive;
